import { useNavigate, useParams } from "react-router";
import { useContext, useEffect, useState } from "react";
import MyContext from "../../context/Context";
import Loader from "../../components/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { DLT, ADD, REMOVE } from '../../redux/Actions/action';
import { collection, getDocs, query, where } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";

function Category() {
    const { categoryname } = useParams();
    const context = useContext(MyContext);
    const { getAllProduct, loading } = context;
    const cartItems = useSelector((state) => state.cartreducer.carts);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [sortOption, setSortOption] = useState("");
    const [deliveredProducts, setDeliveredProducts] = useState({});

    const handleProductClick = (product) => {
        // Get the existing last visited products from localStorage
        let lastVisitedProducts = JSON.parse(localStorage.getItem("lastVisitedProducts")) || [];
    
        // Check if the product already exists in the list (to prevent duplicates)
        lastVisitedProducts = lastVisitedProducts.filter(p => p.id !== product.id);
    
        // Add the new product at the beginning of the array
        lastVisitedProducts.unshift(product);
    
        // Keep only the last 5 products
        lastVisitedProducts = lastVisitedProducts.slice(0,8);
    
        // Store back in localStorage
        localStorage.setItem("lastVisitedProducts", JSON.stringify(lastVisitedProducts));
    
        // Navigate to product info page
        navigate(`/productinfo/${product.id}`);
    };
    
    // Fetch delivered orders
    const getDeliveredOrders = async () => {
        try {
            const q = query(collection(fireDB, "order"), where("status", "==", "delivered"));
            const querySnapshot = await getDocs(q);
            const deliveredItems = {};

            querySnapshot.forEach((doc) => {
                const orderData = doc.data();
                orderData.cartItems.forEach((item) => {
                    deliveredItems[item.id] = true; // Mark product as delivered
                });
            });

            setDeliveredProducts(deliveredItems);
        } catch (error) {
            console.log(error);
            toast.error("Failed to load orders");
            
        }
    };

    const addCart = (item) => {
        dispatch(ADD(item));
        toast.success("Added to cart");
    };

    useEffect(() => {
        localStorage.setItem('cart', JSON.stringify(cartItems));
    }, [cartItems]);

    useEffect(() => {
        window.scrollTo(0, 0);
        getDeliveredOrders()
    }, []);
    

    let filterProduct = getAllProduct.filter((obj) => obj.category.includes(categoryname));
    
    if (sortOption === "lowToHigh") {
        filterProduct.sort((a, b) => a.price - b.price);
    } else if (sortOption === "highToLow") {
        filterProduct.sort((a, b) => b.price - a.price);
    }

    return (
        <div className=" bg-slate-100">
        
            <div className=" pt-10 text-center mb-5">
                <h1 className="text-2xl font-semibold first-letter:uppercase">{categoryname}</h1>
            </div>

            <div className="flex justify-start ml-12 mb-5">
                <label className="mr-2 text-lg">Sort by:</label>
                <select
                    className=" px-3 py-1 rounded-2xl cursor-pointer"
                    value={sortOption}
                    onChange={(e) => setSortOption(e.target.value)}
                >
                    <option value="">Choose price filter</option>
                    <option value="lowToHigh">Price: Low to High</option>
                    <option value="highToLow">Price: High to Low</option>
                </select>
            </div>

            {loading ? (
                <div className="flex justify-center">
                    <Loader />
                </div>
            ) : (
                <section className="text-gray-600 body-font">
                    <div className="container px-5 py-5 mx-auto">
                        <div className="flex flex-wrap -m-4">
                            {filterProduct.length > 0 ? (
                                filterProduct.map((item, index) => {
                                    const { id, title, price, productImageUrl } = item;
                                    const images = Array.isArray(productImageUrl) ? productImageUrl : productImageUrl ? [productImageUrl] : [];
                                    const isSold = deliveredProducts[id]; // Check if product is sold
                                  
                                    return (
                                        <div key={index} className=" p-4 mx-auto w-[300px] ">
                                        {/* <div key={index} className="p-4 w-full md:w-[300px]"> */}
                                            <div className="card  border  border-gray-300 rounded-xl overflow-hidden shadow-md cursor-pointer">
                                               <div className="flex justify-center bg-white">
                                               {images?.[0] && (
                                                    <img
                                                          onClick={() => handleProductClick(item)}
                                                        src={images[0]}
                                                        alt="Product"
                                                        // className="lg:h-56 h-[320px] px-1 py-3"
                                                          className="lg:h-56 h-[200px] px-1 py-3"
                                                    />
                                                )}
                                               </div>
                                              
                                                <div className="p-6">
                                                <h2 className="tracking-widest text-xs title-font font-medium text-gray-500 mb-1">
                                                Xchangehub
                                            </h2>
                                                    <h1 className="font-poppins text-sm font-semibold text-gray-900 mb-3">
                                                        {title.substring(0, 25)}
                                                    </h1>
                                                     {/* Price Section with Discount */}
                                            <div className="flex mb-2 items-center space-x-2">
                                                <span className="text-gray-700 line-through text-lg font-semibold">
                                                ₹{Math.round(price * 1.10)} 
                                                </span>
                                                <span className="text-black font-semibold text-lg">
                                                ₹{price}
                                                </span>
                                               
                                            </div>
                                                     {/* Conditional Button */}
                                            <button
                                                onClick={() => addCart(item)}
                                                className={`w-full py-[4px] rounded-lg font-poppins
                                                    ${isSold ? "cart-btn cursor-not-allowed" : "cart-btn text-white"}`}
                                                disabled={isSold}
                                            >
                                                {isSold ? "Sold" : "Add to Cart"}
                                            </button>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="text-center">
                                    <div className="flex justify-center">
                                        <img className="w-24 mb-2" src="https://cdn-icons-png.flaticon.com/128/2748/2748614.png" alt="No Products" />
                                    </div>
                                    <h1 className="text-black text-xl">No {categoryname} product found</h1>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            )}
        </div>
    );
}

export default Category;